<template>
    <div class="content">
        <div
            class="item"
            v-for="(item, index) in $siteConfig.adList"
            :key="index"
            @click="handleClick(item)"
        >
            <img
                :src="item.image"
                class="ad-image"
                alt="ad"
                loading="lazy"
            />
        </div>

        <el-dialog
            title=""
            :visible.sync="dialogVisible"
            :width="'690px'">
            <div class="flex">
                <div
                    class="bz-item"
                    v-for="(item, index) in $siteConfig.bzList"
                    :key="index"
                    @click="handleClick(item)"
                    :style="{ backgroundImage: `url(${item.image})`,backgroundSize:'100% 100%',backgroundRepeat:'no-repeat' }" 
                >
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data() {
        return {
            dialogVisible: false,
        };
    },
    methods: {
        handleClick(item) {
            if(item.type =='tbwjzz'){
                this.dialogVisible = true;
                return
            }
            if (item.url) {
                this.$post(`${this.$store.state.api.webUrl}/index/information/gatherinfo.json`, {type: this.$siteConfig.planName, str1: item.text, str2: 'advert'}, data => {});
                window.open(item.url, '_blank');
            }else{
                this.$message({
                    message: '该功能暂未开放！',
                    type: 'warning'
                });
            }
        },
    },
};
</script>

<style lang='scss' scoped>
.content {
    display: flex;
    height: 120px;
    margin-top: 10px;
    justify-content: space-between;
    .item {
        width: 24%;
        background: #fff;
        border-radius: 5px;
        cursor: pointer;
        transition: opacity 0.3s;
        font-size: 20px;
        text-align: center;
        user-select: none;
        &:hover {
            opacity: 0.8;
        }
        .ad-image {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    .flex{
        display: flex;
        justify-content: space-between;
        padding: 0px 10px;
    }

    .bz-item{
        width: 300px;
        height: 131px;
        font-size: 26px;
        color: #025FFF;
        padding-left: 37px;
        line-height: 131px;
        cursor: pointer;
        user-select: none;

        &:hover {
            opacity: 0.8;
        }
    }
}
</style>